import { CreateUserModel } from "../models/CreateUserModel"
import Customer from "../models/Customer"

/**
 * Sign in actions
 */
export const SIGNIN = "SIGNIN"
export interface SignInAction {
    type: typeof SIGNIN,
    payload: {
        email: string,
        password: string
    }
}
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS"
export interface SignInSuccessAction {
    type: typeof SIGNIN_SUCCESS,

}

export const LOAD_USER_INFO = "LOAD_USER_INFO"

export interface LoadUserInfoAction {
    type: typeof LOAD_USER_INFO,
}
export const LOAD_USER_INFO_SUCCESS = "LOAD_USER_INFO_SUCCESS"

export interface LoadUserInfoSuccessAction {
    type: typeof LOAD_USER_INFO_SUCCESS,
    payload: {
        customer: Customer | null
    }

}
export const LOAD_USER_INFO_ERROR = "LOAD_USER_INFO_ERROR"

export interface LoadUserInfoErrorAction {
    type: typeof LOAD_USER_INFO_ERROR,
}

//TODO: Handle error auth from firebase
export const SIGNIN_FAIL = "SIGNIN_FAIL"
export interface SignInFailAction {
    type: typeof SIGNIN_FAIL
    payload?: string
}

/**
 * Sign up actions
 */
export const SIGNUP = "SIGNUP"
export interface SignUpAction {
    type: typeof SIGNUP,
    payload: CreateUserModel
}
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS"
export interface SignUpSuccessAction {
    type: typeof SIGNUP_SUCCESS
}
export const SIGNUP_FAIL = "SIGNUP_FAIL"
export interface SignUpFailAction {
    type: typeof SIGNUP_FAIL,
    payload?: string
}

export const AUTHORIZE_WITH_TOKEN = "AUTHORIZE_WITH_TOKEN"
export interface AuthorizeWithTokenAction {
    type: typeof AUTHORIZE_WITH_TOKEN,
    payload: {
        accessToken: string;
        refreshToken: string;
    }
}

/**
 * Recovery password Actions
 */

export const RECOVERY_PASSWORD = "RECOVERY_PASSWORD"
export interface RecoveryPasswordAction {
    type: typeof RECOVERY_PASSWORD
    payload: string
}
export const RECOVERY_PASSWORD_SUCCESS = "RECOVERY_PASSWORD_SUCCESS"
export interface RecoveryPasswordSuccessAction {
    type: typeof RECOVERY_PASSWORD_SUCCESS
}
export const RECOVERY_PASSWORD_FAIL = "RECOVERY_PASSWORD_FAIL"
export interface RecoveryPasswordFailAction {
    type: typeof RECOVERY_PASSWORD_FAIL,
    payload?: string
}

/**
 * Sign out actions
 */

export const SIGNOUT = "SIGNOUT"
export interface SignOutAction {
    type: typeof SIGNOUT,
}
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS"
export interface SignOutSuccessAction {
    type: typeof SIGNOUT_SUCCESS
}
export const SIGNOUT_FAIL = "SIGNOUT_FAIL"
export interface SignOutFailAction {
    type: typeof SIGNOUT_FAIL,
    payload?: string
}

export const CLEAN_ERROR_STATE = "CLEAN_ERROR_STATE"
export interface CleanErrorStateAction {
    type: typeof CLEAN_ERROR_STATE
}

export const UPDATE_USER = "UPDATE_USER"
export interface UpdateUserAction {
    type: typeof UPDATE_USER,
    payload: {
        firstname: string,
        lastname: string
    }
}

export type SharedAuthenticationActionsType =
    | SignInAction
    | SignInSuccessAction
    | SignInFailAction
    | SignUpAction
    | SignUpSuccessAction
    | SignUpFailAction
    | RecoveryPasswordAction
    | RecoveryPasswordSuccessAction
    | RecoveryPasswordFailAction
    | SignOutAction
    | SignOutSuccessAction
    | SignOutFailAction
    | CleanErrorStateAction
    | LoadUserInfoAction
    | LoadUserInfoSuccessAction
    | LoadUserInfoErrorAction
    | AuthorizeWithTokenAction
    | UpdateUserAction;

export const sharedAuthenticationsActions = {

    updateUser: (firstname: string, lastname: string): UpdateUserAction => {
        return {
            type: UPDATE_USER,
            payload: {
                firstname: firstname,
                lastname: lastname,
            },
        }
    },
    /**
    * Sign in actions
    * @returns
    */
    signIn: (email: string, password: string): SignInAction => {
        return {
            type: SIGNIN,
            payload: {
                email: email,
                password: password,
            },
        }
    },
    signInSuccess: (): SignInSuccessAction => {
        return {
            type: SIGNIN_SUCCESS,
        }
    },
    signInFail: (error?: string): SignInFailAction => {
        return {
            type: SIGNIN_FAIL,
            payload: error,
        }
    },

    /**
     * Sign up actions
     * @returns
     */
    signUp: (user: CreateUserModel): SignUpAction => {
        return {
            type: SIGNUP,
            payload: user,
        }
    },
    signUpSuccess: (): SignUpSuccessAction => {
        return {
            type: SIGNUP_SUCCESS,
        }
    },
    signUpFail: (error?: string): SignUpFailAction => {
        return {
            type: SIGNUP_FAIL,
            payload: error,
        }
    },
    /**
     * Recovery Password actions
     * @returns
     */
    recoveryPassword: (email: string): RecoveryPasswordAction => {
        return {
            type: RECOVERY_PASSWORD,
            payload: email,
        }
    },
    recoveryPasswordSuccess: (): RecoveryPasswordSuccessAction => {
        return {
            type: RECOVERY_PASSWORD_SUCCESS,

        }
    },
    recoveryPasswordFail: (error?: string): RecoveryPasswordFailAction => {
        return {
            type: RECOVERY_PASSWORD_FAIL,
            payload: error,
        }
    },

    /**
     * Sign out Actions
     * @returns
     */
    signOut: (): SignOutAction => {
        return {
            type: SIGNOUT,
        }
    },
    signOutSuccess: (): SignOutSuccessAction => {
        return {
            type: SIGNOUT_SUCCESS,

        }
    },
    signOutFail: (error?: string): SignOutFailAction => {
        return {
            type: SIGNOUT_FAIL,
            payload: error,
        }
    },

    clearErrorState: (): CleanErrorStateAction => {
        return {
            type: CLEAN_ERROR_STATE,
        }
    },

    loadUserInfo: (): LoadUserInfoAction => {
        return {
            type: LOAD_USER_INFO,
        }
    },
    loadUserInfoSuccess: (customer: Customer | null): LoadUserInfoSuccessAction => {
        return {
            type: LOAD_USER_INFO_SUCCESS,
            payload: {
                customer: customer,
            },
        }
    },
    loadUserInfoError: (): LoadUserInfoErrorAction => {
        return {
            type: LOAD_USER_INFO_ERROR,
        }
    },

    authorizeWithToken: (accessToken: string, refreshToken: string): AuthorizeWithTokenAction => {
        return {
            type: AUTHORIZE_WITH_TOKEN,
            payload: {
                accessToken: accessToken,
                refreshToken: refreshToken,
            },
        }
    },
}